module.exports = __webpack_public_path__ + "img/tp2.fa5f6603.png";